/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    arrayOf, bool, shape, string,
} from 'prop-types';
import { useSelector } from 'react-redux';

// Helpers
import { getFeatureFlags } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { dateMMMMDDYYYY } from '../../../utils/dateString';
import Helper from '../../../state/reducers/Helper';

const DesktopDeliveryDate = (props)  => {
    const { ROSSOrder, isROSSPassport } = props;
    const ROSSPassportDeliveryDate = dateMMMMDDYYYY(ROSSOrder?.billingProfile?.orderDate || '');

    const featureFlags = useSelector(getFeatureFlags);

    const deliveryHelper = (
        {
            arrivalStartDate,
            arrivalEndDate,
            flexGuaranteedFlag,
            flexMessage,
            flexDate,
            deliveryDate,
            itemType,
        },
        estimatedDeliveryDate,
    ) => {
        const productBrand = ROSSOrder?.items?.[0]?.productBrand;

        const isShowFlexLabelEnabled = featureFlags['is-show-flex-label-enabled'];

        const exactDeliveryDate = deliveryDate || '';
        const isflexDate = flexDate !== '' && flexMessage !== '' && flexGuaranteedFlag === 'N';

        const deliveryData = Helper.getDeliveryDate(exactDeliveryDate, arrivalStartDate, arrivalEndDate, productBrand, isflexDate, estimatedDeliveryDate);
        const deliveryLabel = deliveryData.deliveryLabel || '';
        const deliveryDateText = deliveryData.deliveryDate || '';

        return (
            <>
                {deliveryDateText.indexOf('null') === -1 ? (
                <div className="bold" style={{ maxWidth: '80%' }}>{deliveryLabel} {deliveryDateText}</div>
                ) : (
                ''
                )}
                {
                isShowFlexLabelEnabled && itemType === 'FPT' && flexGuaranteedFlag === 'N' && flexMessage !== '' && (
                    <div className="align-left">
                            {flexMessage}
                    </div>
                )
                }
            </>
        );
   };

    return (
        <>
            {isROSSPassport ? (
                <>
                    <h2 className="gray-color">
                        Membership Start Date:{' '}
                    </h2>
                    <span className="normal bold body-color no-uppercase">
                        {ROSSPassportDeliveryDate}
                    </span>
                </>
            ) : (
                <>
                    <h2 className="gray-color">
                        <div className="split align-center">
                            <div className="align-left">
                                Delivery Date
                            </div>

                        </div>
                    </h2>
                    <div className="margin-bottom">
                        <div>
                            {deliveryHelper(
                                ROSSOrder.items[0],
                                ROSSOrder.estimatedDeliveryDate,
                            )}
                        </div>
                    </div>
                    {ROSSOrder.items[0].dtwName && (
                        <>
                            <h2 className="gray-color margin-top">
                                <div className="split align-center">
                                    <div className="align-left">
                                        Requested Time
                                    </div>
                                </div>
                            </h2>
                            <div className="margin-bottom">
                                <div className="bold">
                                    {ROSSOrder.items[0].dtwName}
                                </div>
                            </div>
                        </>
                    )}
                </>
            )}
        </>
    );
};

DesktopDeliveryDate.defaultProps = {
   ROSSOrder: {},
   isROSSPassport: false,
};

DesktopDeliveryDate.propTypes = {
    ROSSOrder: shape({
        type: string,
        deliveryStatus: string,
        items: arrayOf(shape({
            deliveryDate: string,
        })),
    }),
    isROSSPassport: bool,
};

export default DesktopDeliveryDate;
